import React, { Component } from "react";
import Confirm from "./Confirm";
import Success from "./Success";
import FormPhoneLookup from "./FormPhoneLookup";
import FormInformation from "./FormInformation";
import FormTime from "./FormTime";
import FormServiceType from "./FormServiceType";
import { format } from "./../services/phone";

export class UserForm extends Component {
  state = {
    storeId: process.env.REACT_APP_STORE_ID,
    paramSession: "",
    step: 1,
    serviceTypeRequired: false,
    pickupOptionEnabled: false,
    notesEnabled: false,
    availableCalendar: "",
    phone: "",
    optedIn: true,
    pickup: false,
    notes: "",
    date: "",
    firstName: "",
    lastName: "",
    email: "",
    paramPhone: "",
    paramEmail: "",
    paramFirstName: "",
    paramLastName: "",
    paramStoreId: "",
    paramCampaignId: "",
  };

  // Proceed to next step
  nextStep = () => {
    const { step } = this.state;
    this.props.changeProgress((step + 1) * 16.68);
    this.setState({
      step: step + 1,
    });
  };

  // Proceed to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };

  // Proceed to specific step
  goToStep = (stepNo) => {
    this.setState({
      step: stepNo,
    });
  };

  // Handle fields change
  handleChange = (newState) => {
    this.setState(newState);
  };

  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let paramStoreId = params.get("storeId");
    let paramSession = params.get("session");
    let paramPhone = params.get("phone");
    let paramFirstName = params.get("firstName");
    let paramLastName = params.get("lastName");
    let paramEmail = params.get("email");
    let paramServiceType = params.get("serviceType");
    let paramCampaignId = params.get("campaignId");

    this.setState({
      paramStoreId,
      paramPhone,
      paramFirstName,
      paramLastName,
      paramEmail,
      paramServiceType,
      paramCampaignId,
      paramSession,
    });

    if (paramStoreId !== null && paramStoreId !== this.state.storeId) {
      this.handleChange({
        storeId: paramStoreId,
      });
    }

    if (paramPhone !== null && paramPhone !== this.state.phone) {
      this.handleChange({
        phone: format(paramPhone),
      });
    }

    if (paramFirstName !== null && paramFirstName !== this.state.firstName) {
      this.handleChange({
        firstName: paramFirstName,
      });
    }

    if (paramLastName !== null && paramLastName !== this.state.lastName) {
      this.handleChange({
        lastName: paramLastName,
      });
    }

    if (paramEmail !== null && paramEmail !== this.state.email) {
      this.handleChange({
        email: paramEmail,
      });
    }

    console.log("Input Params", {
      paramStoreId,
      paramPhone,
      paramFirstName,
      paramLastName,
      paramEmail,
      paramServiceType,
      paramCampaignId,
    });

    if (paramPhone != null && paramPhone !== "") {
      console.log("Skipping the step 1 as phone number is already provided");
      this.nextStep();
    }
  }

  render() {
    const { step } = this.state;
    const {
      storeId,
      firstName,
      lastName,
      email,
      optedIn,
      pickup,
      phone,
      date,
      availableCalendar,
      serviceType,
      notes,
      paramPhone,
      paramFirstName,
      paramLastName,
      paramEmail,
      paramServiceType,
      serviceTypeRequired,
      pickupOptionEnabled,
      notesEnabled,
      paramCampaignId,
      paramSession,
    } = this.state;
    const values = {
      storeId,
      firstName,
      lastName,
      email,
      optedIn,
      pickup,
      phone,
      date,
      availableCalendar,
      serviceType,
      notes,
      paramPhone,
      paramFirstName,
      paramLastName,
      paramEmail,
      paramServiceType,
      serviceTypeRequired,
      pickupOptionEnabled,
      notesEnabled,
      paramCampaignId,
      paramSession,
    };

    switch (step) {
      case 1:
        return <FormPhoneLookup nextStep={this.nextStep} handleChange={this.handleChange} values={values} />;
      case 2:
        return <FormInformation nextStep={this.nextStep} prevStep={this.prevStep} handleChange={this.handleChange} values={values} />;
      case 3:
        return <FormServiceType nextStep={this.nextStep} prevStep={this.prevStep} handleChange={this.handleChange} values={values} />;
      case 4:
        return <FormTime nextStep={this.nextStep} prevStep={this.prevStep} handleChange={this.handleChange} values={values} />;
      case 5:
        return <Confirm nextStep={this.nextStep} goToStep={this.goToStep} handleChange={this.handleChange} prevStep={this.prevStep} values={values} />;
      case 6:
      default:
        return <Success />;
    }
  }
}

export default UserForm;
